import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Root from '../../components/Root';
import SayHi from '../../components/SayHi';
import NotFoundPage from '../../components/NotFoundPage';

import Footer from '../../components/Footer';

import * as Css from './styles';

const Routing = () => {
  return (
    <Router>
      <Css.Wrap>
        <Css.Align>
          <Switch>
            <Route path="/" exact component={Root} />

            <Route path="/sayhi" component={SayHi} />

            <Route component={NotFoundPage} />
          </Switch>
        </Css.Align>
        <Footer />
      </Css.Wrap>
    </Router>
  );
};

export default Routing;
